@if (showPanel) {
<div class="kyb-status">
  <div class="kyb-status-panel" [class.kyb-status-panel-failed]="showingFailure">
    <div class="kyb-status-badge">
      @if (showingFailure) {
        <span class="mdi mdi-alert-outline"></span>
      } @else {
        <mat-spinner [diameter]="26" [strokeWidth]="2"></mat-spinner>
      }
    </div>
    <div class="kyb-status-content">
      <div class="kyb-status-title">{{ waitTitle }}</div>
      <div class="kyb-status-message">{{ waitMessage }}</div>
    </div>
  </div>

  @if (showAction) {
    <div class="kyb-status-actions">
      <button mat-flat-button color="primary" [disabled]="actionDisabled" (click)="onRetry()">
        {{ actionLabel }}
      </button>
      @if (showRetry || displayStatus === 'failed') {
        <button mat-stroked-button color="primary" [disabled]="actionDisabled" (click)="onManualEntry()">
          Enter manually
        </button>
      }
    </div>
  }
</div>
}
